import React, { FC } from 'react'
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import styles from 'styles/components/calendar.module.scss'
import { parseToDate } from 'lib/helper'
import { StoreCalendarType } from 'types/storeCalendar'

type Props = {
  storeCalendars: StoreCalendarType[]
}

const StoreCalendarsLabel: FC<Props> = (props) => {
  const { storeCalendars } = props
  return (
    <p className={styles.business__holiday}>
      {storeCalendars.length === 0
        ? 'なし'
        : storeCalendars.map((storeCalendar, index) => {
            const date = format(parseToDate(storeCalendar.date), 'M/d(E)', { locale: ja })
            if (index === 0) {
              return date
            } else {
              return ', ' + date
            }
          })}
    </p>
  )
}

export default StoreCalendarsLabel
